<!--
    The compact dropdown the narrow layouts show in place of the pencil and the
    arrows — the same actions, gathered under one "Block" button.
-->
<div class="small-block-controls">
    <div class="btn-group" dropdown (onShown)="isShowDropDownMenu(true)" (onHidden)="isShowDropDownMenu(false)">
        <button class="btn-control dropdown-toggle" dropdownToggle type="button">
            <span class="sp-icon icon-option-horizontal"> </span> <small>{{ "control_block" | translate }}</small>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-custom-right" role="menu">
            <li role="menuitem">
                <a class="dropdown-item" (click)="selectAction()">
                    <span class="sp-icon icon-pencil"> </span>
                    {{ "edit" | translate }}
                </a>
            </li>
            <li role="menuitem">
                <a class="dropdown-item" (click)="copyAction()">
                    <span class="sp-icon icon-copy"> </span>
                    {{ "duplicate" | translate }}
                </a>
            </li>
            @if (saveBlockToGallery()) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="saveBlockToLibraryAction()">
                        <span class="sp-icon icon-heart-empty"> </span>
                        {{ "save_to_gallery" | translate }}
                    </a>
                </li>
            }
            <li><hr /></li>
            <li role="menuitem" [class.disabled]="disableMoveUp() || isPinned()">
                <a class="dropdown-item" (click)="moveUpAction()">
                    <span class="sp-icon icon-arrow-up1"> </span>
                    {{ "move_up" | translate }}
                </a>
            </li>
            <li role="menuitem" [class.disabled]="disableMoveDown() || isPinned()">
                <a class="dropdown-item" (click)="moveDownAction()">
                    <span class="sp-icon icon-arrow-down1"> </span>
                    {{ "move_down" | translate }}
                </a>
            </li>
            <li><hr /></li>
            <li role="menuitem">
                <a class="dropdown-item" (click)="deleteAction()">
                    <span class="sp-icon icon-bin color-danger"> </span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>

<div class="main-controls">
    <button
        class="btn-control click-outside-close-prevent btn-edit-action"
        [tooltip]="selectActionTooltip()"
        (click)="selectAction()"
    >
        <span class="sp-icon icon-pencil"> </span>
    </button>
    <div
        class="btn-group"
        dropdown
        (onShown)="isShowDropDownMenu(true)"
        (onHidden)="isShowDropDownMenu(false)"
        container="body"
    >
        <button class="btn-control dropdown-toggle" dropdownToggle type="button">
            <span class="sp-icon icon-option-horizontal"> </span>
        </button>
        <ul *dropdownMenu class="dropdown-menu dropdown-menu-right dropdown-custom-right" role="menu">
            <li role="menuitem">
                <a class="dropdown-item" (click)="copyAction()">
                    <span class="sp-icon icon-copy"> </span>
                    {{ "duplicate" | translate }}
                </a>
            </li>
            @if (saveBlockToGallery()) {
                <li role="menuitem">
                    <a class="dropdown-item" (click)="saveBlockToLibraryAction()">
                        <span class="sp-icon icon-heart-empty"> </span>
                        {{ "save_to_gallery" | translate }}
                    </a>
                </li>
            }
            <li><hr /></li>
            <li role="menuitem">
                <a class="dropdown-item" (click)="deleteAction()">
                    <span class="sp-icon icon-bin color-danger"> </span>
                    {{ "delete" | translate }}
                </a>
            </li>
        </ul>
    </div>
</div>

@if (isPinned()) {
    <div class="move-controls" [tooltip]="pinnedTooltip">
        <ng-template #pinnedTooltip>
            {{ "disabled_move_btn_tooltip" | translate }}
        </ng-template>
        <button class="btn-control disabled">
            <span class="sp-icon icon-arrow-up1"> </span>
        </button>
        <button class="btn-control disabled">
            <span class="sp-icon icon-arrow-down1"> </span>
        </button>
    </div>
} @else {
    <div class="move-controls">
        <button class="btn-control" [class.disabled]="disableMoveUp()" (click)="moveUpAction()">
            <span class="sp-icon icon-arrow-up1"> </span>
        </button>
        <button class="btn-control" [class.disabled]="disableMoveDown()" (click)="moveDownAction()">
            <span class="sp-icon icon-arrow-down1"> </span>
        </button>
    </div>
}
